<button class="-type-icon -color-default-clear"
        (click)="toggleNavMenu()">
  <i class="ion ion-md-menu"></i>
</button>
